const hooks = {
  useDetectPredefinedNotifications: require('../hooks/useDetectPredefinedNotifications').default,
};

export default hooks;
